// extracted by mini-css-extract-plugin
export default {"order-success-wrapper":"OrderSuccess_order-success-wrapper__xIvuB","back-to-main-button":"OrderSuccess_back-to-main-button__jRmjv"};